import { urlApi } from "./urls";
import { base64ToBytes } from "./utils";
import { toast } from "react-toastify";
import { changeDateFormat, numberWithCommas } from "./utils";

const stringError = (err) => {
  switch (err) {
    case "plan only allows 4 card":
      return "Exceed number of cards";
    case "user is not first login":
      return "You are not available using the promo!";
    default:
      return "Something went wrong, try again later!";
  }
};

const postGift = (token, setLoading, setDone) => {
  try {
    fetch(urlApi + "/v1/gift/first-login-mission", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const user = JSON.parse(localStorage.getItem("user_info"));
        if (data.errors) {
          toast.error(stringError(data.errors[0]), {
            position: "top-center",
            autoClose: 3000,
          });
        } else {
          const packageData = data.data.package;
          const pckg = {
            package_id: packageData.package_id,
            name: packageData.name,
            slug: packageData.slug,
            period_end_at: packageData.period_end_at,
          };
          user.package = pckg;
          toast.success("Congrats! You got 1 month free!", {
            position: "top-center",
            autoClose: 3000,
          });
        }
        user.is_first_login = false;
        localStorage.setItem("user_info", JSON.stringify(user));
        setLoading(false);
        localStorage.removeItem("mission");
        setDone(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Something went wrong, please contact our team!", {
          position: "top-center",
          autoClose: 3000,
        });
        localStorage.removeItem("mission");
        setDone(false);
      });
  } catch {}
};

const getAllCards = (token, setCards) => {
  try {
    fetch(urlApi + "/v1/dashboard/card", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setCards(data.data);
      })
      .catch((error) => {
        setCards([]);
      });
  } catch {
    setCards([]);
  }
};

const getAllBackgrounds = (token, setBackgrounds) => {
  try {
    fetch(urlApi + "/v1/virtual-background", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setBackgrounds(data.data);
      })
      .catch((error) => {
        setBackgrounds([]);
      });
  } catch {
    setBackgrounds([]);
  }
};

const getAllSignatures = (token, setSignatures) => {
  try {
    fetch(urlApi + "/v1/email-signature", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setSignatures(data.data);
      })
      .catch((error) => {
        setSignatures([]);
      });
  } catch {
    setSignatures([]);
  }
};

const createCard = (
  token,
  data,
  setLoading,
  setShowError,
  setErrorMsg,
  navigate,
) => {
  try {
    fetch(urlApi + "/v1/dashboard/card", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          setLoading(false);
          toast.error(stringError(data.errors[0]), {
            position: "top-center",
            autoClose: 3000,
          });
          return false;
        }
        localStorage.setItem("toastMsg", "Card created");
        let mission = JSON.parse(localStorage.getItem("mission"));
        if (mission) {
          mission.create_card = true;
          localStorage.setItem("mission", JSON.stringify(mission));
        }

        navigate("/");
        return true;
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error("Something went wrong, try again later!", {
          position: "top-center",
          autoClose: 3000,
        });
        return false;
      });
  } catch {
    setLoading(false);
    setErrorMsg("Something went wrong, try again later!");
    setShowError(true);
    return false;
  }
};

const createSignature = (
  token,
  data,
  setLoading,
  setShowError,
  setErrorMsg,
  navigate,
) => {
  try {
    fetch(urlApi + "/v1/email-signature", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          setLoading(false);
          toast.error(stringError(data.errors[0]), {
            position: "top-center",
            autoClose: 3000,
          });
          return false;
        }
        localStorage.setItem("toastMsg", "Email signature created");
        navigate("/signatures");
        return true;
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error("Something went wrong, try again later!", {
          position: "top-center",
          autoClose: 3000,
        });
        return false;
      });
  } catch {
    setLoading(false);
    setErrorMsg("Something went wrong, try again later!");
    setShowError(true);
    return false;
  }
};

const createBackground = (
  token,
  data,
  setLoading,
  setShowError,
  setErrorMsg,
  navigate,
) => {
  try {
    fetch(urlApi + "/v1/virtual-background", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          setLoading(false);
          toast.error(stringError(data.errors[0]), {
            position: "top-center",
            autoClose: 3000,
          });
          return false;
        }
        localStorage.setItem("toastMsg", "Virtual background created");
        navigate("/backgrounds");
        return true;
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error("Something went wrong, try again later!", {
          position: "top-center",
          autoClose: 3000,
        });
        return false;
      });
  } catch {
    setLoading(false);
    setErrorMsg("Something went wrong, try again later!");
    setShowError(true);
    return false;
  }
};

const updateBackground = (
  token,
  backgroundId,
  data,
  setLoading,
  setShowError,
  setErrorMsg,
  navigate,
) => {
  try {
    fetch(urlApi + "/v1/virtual-background/" + backgroundId, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          setLoading(false);
          toast.error(stringError(data.errors[0]), {
            position: "top-center",
            autoClose: 3000,
          });
          return false;
        }
        localStorage.setItem("toastMsg", "Virtual background updated");
        navigate("/backgrounds");
        return true;
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error("Something went wrong, try again later!", {
          position: "top-center",
          autoClose: 3000,
        });
        return false;
      });
  } catch {
    setLoading(false);
    setErrorMsg("Something went wrong, try again later!");
    setShowError(true);
    return false;
  }
};

const updateSignature = (
  token,
  emailSignatureId,
  data,
  setLoading,
  setShowError,
  setErrorMsg,
  navigate,
) => {
  try {
    fetch(urlApi + "/v1/email-signature/" + emailSignatureId, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          setLoading(false);
          toast.error(stringError(data.errors[0]), {
            position: "top-center",
            autoClose: 3000,
          });
          return false;
        }
        localStorage.setItem("toastMsg", "Email signature updated");
        navigate("/signatures");
        return true;
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error("Something went wrong, try again later!", {
          position: "top-center",
          autoClose: 3000,
        });
        return false;
      });
  } catch {
    setLoading(false);
    setErrorMsg("Something went wrong, try again later!");
    setShowError(true);
    return false;
  }
};

const getSignature = (token, emailSgId, setSignatureData) => {
  try {
    fetch(urlApi + "/v1/email-signature/" + emailSgId, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          toast.error("Something went wrong, try again later!", {
            position: "top-center",
            autoClose: 3000,
          });
          return false;
        }
        const signatureData = data.data[0];
        setSignatureData(signatureData);
        return true;
      })
      .catch((error) => {
        console.log(error);
        toast.error("Something went wrong, try again later!", {
          position: "top-center",
          autoClose: 3000,
        });
        return false;
      });
  } catch {
    toast.error("Something went wrong, try again later!", {
      position: "top-center",
      autoClose: 3000,
    });
    return false;
  }
};

const getBackground = (token, backgroundId, setBackgroundData) => {
  try {
    fetch(urlApi + "/v1/virtual-background/" + backgroundId, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          toast.error("Something went wrong, try again later!", {
            position: "top-center",
            autoClose: 3000,
          });
          return false;
        }
        const backgroundData = data.data[0];
        setBackgroundData(backgroundData);
        return true;
      })
      .catch((error) => {
        console.log(error);
        toast.error("Something went wrong, try again later!", {
          position: "top-center",
          autoClose: 3000,
        });
        return false;
      });
  } catch {
    toast.error("Something went wrong, try again later!", {
      position: "top-center",
      autoClose: 3000,
    });
    return false;
  }
};

const getUserPackage = (token, setPackageData = null) => {
  try {
    fetch(urlApi + "/v1/user-package", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          toast.error("Something went wrong, try again later!", {
            position: "top-center",
            autoClose: 3000,
          });
          return false;
        }
        const packageData = data.data[0].package;
        const pckg = {
          package_id: packageData.package_id,
          name: packageData.name,
          slug: packageData.slug,
          period_end_at: packageData.period_end_at,
        };
        const user = JSON.parse(localStorage.getItem("user_info"));
        user.package = pckg;
        localStorage.setItem("user_info", JSON.stringify(user));
        if (setPackageData != null) {
          setPackageData(pckg);
        }
        return true;
      })
      .catch((error) => {
        console.log(error);
        toast.error("Something went wrong, try again later!", {
          position: "top-center",
          autoClose: 3000,
        });
        setShowError(true);
        return false;
      });
  } catch {
    toast.error("Something went wrong, try again later!", {
      position: "top-center",
      autoClose: 3000,
    });
    return false;
  }
};

const getUserTransactions = (token, setTrasactions) => {
  try {
    fetch(urlApi + "/v1/payment", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          toast.error("Something went wrong, try again later!", {
            position: "top-center",
            autoClose: 3000,
          });
          return false;
        }
        const transactions = data.data.map((val, _) => {
          return {
            date: changeDateFormat(val.updated_at),
            transaction_no: val.payment_id,
            package_plan:
              val.package_name + " - " + val.package_interval_month + " months",
            price: "Rp " + numberWithCommas(parseInt(val.total_amount)),
            status: val.status.toUpperCase(),
          };
        });
        setTrasactions(transactions);
        return true;
      })
      .catch((error) => {
        console.log(error);
        toast.error("Something went wrong, try again later!", {
          position: "top-center",
          autoClose: 3000,
        });
        setShowError(true);
        return false;
      });
  } catch {
    toast.error("Something went wrong, try again later!", {
      position: "top-center",
      autoClose: 3000,
    });
    return false;
  }
};

const updateCard = (
  token,
  data,
  cardId,
  setLoading,
  setShowError,
  setErrorMsg,
  navigate,
) => {
  try {
    fetch(urlApi + "/v1/dashboard/card/" + cardId, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          setLoading(false);
          setErrorMsg("Something went wrong, try again later!");
          setShowError(true);
          return false;
        }
        localStorage.setItem("toastMsg", "Card updated");
        navigate("/");
        return true;
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        setErrorMsg("Something went wrong, try again later!");
        setShowError(true);
        return false;
      });
  } catch {
    setLoading(false);
    setErrorMsg("Something went wrong, try again later!");
    setShowError(true);
    return false;
  }
};

const deleteCard = async (token, data) => {
  const cardId = data.card_id;
  let resDeleteData = await fetch(urlApi + "/v1/dashboard/card/" + cardId, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "content-Type": "application/json",
      "Access-Control-Allow-Headers": "*",
      Authorization: "Bearer " + token,
    },
  });
  if (!resDeleteData.ok) {
    return false;
  }
  return true;
};

const deleteSignature = async (token, data) => {
  const SignatureId = data.email_sg_id;
  let resDeleteData = await fetch(
    urlApi + "/v1/email-signature/" + SignatureId,
    {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    },
  );
  if (!resDeleteData.ok) {
    return false;
  }
  return true;
};

const deleteBackground = async (token, data) => {
  const backgroundId = data.virtual_bg_id;
  let resDeleteData = await fetch(
    urlApi + "/v1/virtual-background/" + backgroundId,
    {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    },
  );
  if (!resDeleteData.ok) {
    return false;
  }
  return true;
};

const getAllLookUp = (
  token,
  setColorThemes,
  setCardTemplates,
  setDataLookup,
) => {
  try {
    fetch(urlApi + "/v1/misc/lookup?feature=card", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setColorThemes(
          data.data.Display["Color Theme"].map((v, ind) => ({
            color1: "#" + v.values.split(",")[0],
            color2: "#" + v.values.split(",")[1],
            name: v.display_label,
            id: v.lookup_id,
          })),
        );
        setCardTemplates(
          data.data.Display["Card Template"].map((v, i) => ({
            img: v.image_url,
            name: v.display_label,
            id: v.lookup_id,
          })),
        );
        setDataLookup(data.data);
        return true;
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  } catch {
    return false;
  }
};

const getESLookUp = (token, setStyles) => {
  try {
    fetch(urlApi + "/v1/misc/lookup?feature=email_signature", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setStyles(data.data["Email Signature"]["Email Signature"]);
        return true;
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  } catch {
    return false;
  }
};

const getVCLookUp = (token, setBackgroundImages) => {
  try {
    fetch(urlApi + "/v1/misc/lookup?feature=virtual_background", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setBackgroundImages(
          data.data["Background Images"]["Background Images"],
        );
        return true;
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  } catch {
    return false;
  }
};

const getAllPackages = (token, setDataPackages) => {
  try {
    fetch(urlApi + "/v1/package/PKG118ad3d73e3847eca678d18d762d7781/interval", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.message == "SUCCESS") {
          setDataPackages(data.data);
          return;
        }
        console.log(data.errors);
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  } catch {
    return false;
  }
};

const postPayment = (token, data, setLoading, navigate) => {
  try {
    fetch(urlApi + "/v1/payment", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          setLoading(false);
          toast.error(data.errors[0], {
            position: "top-center",
            autoClose: 3000,
          });
          return false;
        }
        navigate("/payment/" + data.data[0].payment_id);
        return true;
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  } catch {
    return false;
  }
};

const getAllPayment = (token, navigate) => {
  try {
    fetch(urlApi + "/v1/payment", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          return false;
        }
        navigate("/payment/" + data.data[0].payment_id);
        return true;
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  } catch {
    return false;
  }
};

const getSpecificPayment = (token, paymentId, setData, setLoading) => {
  try {
    fetch(urlApi + "/v1/payment/" + paymentId, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          toast.error(data.errors[0], {
            position: "top-center",
            autoClose: 3000,
          });
          return false;
        }
        setData(data.data[0]);
        setLoading(false);
        return true;
      })
      .catch((error) => {
        console.log(error);
        setData({});
        return false;
      });
  } catch {
    setData({});
    return false;
  }
};

const getActivePayment = (token, navigate) => {
  try {
    fetch(urlApi + "/v1/payment/awaiting", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          return false;
        }
        if (data.data.length > 0) {
          navigate("/payment/" + data.data[0].payment_id);
        }
        return true;
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  } catch {
    return false;
  }
};

const getCardBySlug = (slug, setData, navigate) => {
  try {
    fetch(urlApi + "/v1/public/card/" + slug, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setData(data.data[0]);
        return true;
      })
      .catch((error) => {
        console.log(error);
        navigate("/notfound");
        return false;
      });
  } catch {
    return false;
  }
};

const uploadImage = async (token, base64, path, dim = false) => {
  if (dim != false) {
    base64 = await resizeImage(base64, dim[0], dim[1]);
  }

  try {
    const imgbase64 = base64ToBytes(
      base64.replace(/^data:image\/\w+;base64,/, ""),
    );
    const type_ = base64.split(";")[0].split("/")[1];

    let resDataImage = await fetch(urlApi + "/v1/dashboard/image", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        image_path: path,
        image_type: "image/" + type_,
      }),
    });
    if (!resDataImage.ok) {
      return null;
    }
    const data = await resDataImage.json();
    let image_id = data.data.image_id;
    let resPutImage = await fetch(data.data.presigned_url, {
      method: "PUT",
      headers: {
        "content-Type": "image/" + type_,
        "Access-Control-Allow-Headers": "*",
      },
      body: imgbase64,
    });
    if (!resPutImage.ok) throw new Error("Failed to PUT R2");
    let resPutBackend = await fetch(
      urlApi + "/v1/dashboard/image/" + image_id,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          is_active: true,
        }),
      },
    );
    if (!resPutBackend.ok) throw new Error("Failed to PUT image");
    return image_id;
  } catch {
    (e) => {
      console.log("error");
      return null;
    };
  }
};

const getCardById = (id, token, setCard) => {
  try {
    if (true) {
      fetch(urlApi + "/v1/dashboard/card/" + id, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: "Bearer " + token,
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          setCard(data);
        })
        .catch((error) => {
          setCard(null);
        });
    }
  } catch {
    setCard(null);
  }
};

const getAnalytic = (
  token,
  card,
  startDate,
  endDate,
  filterDate,
  setSummary,
  setChartDataEventDay,
  setChartDataEventWeek,
  setChartDataEventMonth,
  setChartDataViewsGeoCity,
  setChartDataViewsGeoProvince,
  setChartDataViewsGeoCountry,
  setChartDataClickSocial,
  setChartDataChannelMethod,
) => {
  try {
    let url = urlApi + "/v1/analytics/card";
    if (startDate != null) {
      url = url + "?" + "start_date=" + startDate + "&end_date=" + endDate;
    }
    if (filterDate != null) {
      url = url + "&filter_date=" + filterDate;
    }
    if (card != null) {
      url = url + "&card_name=" + card;
    }
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setSummary(data.data.summary);
        const eventDayData = data.data.by_eot_day;
        eventDayData.reverse();
        const eventDay = {
          labels: eventDayData.map((item) => item.period_label),
          datasets: [
            {
              label: "Total Views",
              data: eventDayData.map((item) => item.total_views),
              borderColor: "rgb(75, 192, 192)",
            },
            {
              label: "Total Contact Savings",
              data: eventDayData.map((item) => item.total_contact_saving),
              borderColor: "rgb(255, 99, 132)",
            },
            {
              label: "Total Social Card Click",
              data: eventDayData.map((item) => item.total_social_card_clicks),
              borderColor: "rgb(191, 156, 236)",
            },
          ],
        };
        setChartDataEventDay(eventDay);

        const eventWeekData = data.data.by_eot_week;
        eventWeekData.reverse();
        const eventWeek = {
          labels: eventWeekData.map((item) => item.period_label),
          datasets: [
            {
              label: "Total Views",
              data: eventWeekData.map((item) => item.total_views),
              borderColor: "rgb(75, 192, 192)",
            },
            {
              label: "Total Contact Savings",
              data: eventWeekData.map((item) => item.total_contact_saving),
              borderColor: "rgb(255, 99, 132)",
            },
            {
              label: "Total Social Card Click",
              data: eventWeekData.map((item) => item.total_social_card_clicks),
              borderColor: "rgb(191, 156, 236)",
            },
          ],
        };
        setChartDataEventWeek(eventWeek);

        const eventMonthData = data.data.by_eot_month;
        eventMonthData.reverse();
        const eventMonth = {
          labels: eventMonthData.map((item) => item.period_label),
          datasets: [
            {
              label: "Total Views",
              data: eventMonthData.map((item) => item.total_views),
              borderColor: "rgb(75, 192, 192)",
            },
            {
              label: "Total Contact Savings",
              data: eventMonthData.map((item) => item.total_contact_saving),
              borderColor: "rgb(255, 99, 132)",
            },
            {
              label: "Total Social Card Click",
              data: eventMonthData.map((item) => item.total_social_card_clicks),
              borderColor: "rgb(191, 156, 236)",
            },
          ],
        };
        setChartDataEventMonth(eventMonth);

        const viewsGeoCity = data.data.by_geo_city;
        let viewsCity = null;
        if (viewsGeoCity != null) {
          viewsCity = {
            labels: viewsGeoCity.map((item) => item.name),
            datasets: [
              {
                data: viewsGeoCity.map((item) => item.total_views),
                backgroundColor: "rgba(255, 101, 0, 0.75)",
                borderColor: "black",
                borderWidth: 2,
              },
            ],
          };
        }
        setChartDataViewsGeoCity(viewsCity);

        const viewsGeoProvince = data.data.by_geo_province;
        let viewsProvince = null;
        if (viewsGeoProvince != null) {
          viewsProvince = {
            labels: viewsGeoProvince.map((item) => item.name),
            datasets: [
              {
                data: viewsGeoProvince.map((item) => item.total_views),
                backgroundColor: "rgba(255, 101, 0, 0.75)",
                borderColor: "black",
                borderWidth: 2,
              },
            ],
          };
        }
        setChartDataViewsGeoProvince(viewsProvince);

        const viewsGeoCountry = data.data.by_geo_country;
        let viewsCountry = null;
        if (viewsGeoCountry != null) {
          viewsCountry = {
            labels: viewsGeoCountry.map((item) => item.name),
            datasets: [
              {
                data: viewsGeoCountry.map((item) => item.total_views),
                backgroundColor: "rgba(255, 101, 0, 0.75)",
                borderColor: "black",
                borderWidth: 2,
              },
            ],
          };
        }
        setChartDataViewsGeoCountry(viewsCountry);

        const clicksCardSocial = data.data.by_social_category;
        let clicksCard = null;
        if (clicksCardSocial != null) {
          clicksCard = {
            labels: clicksCardSocial.map((item) => item.social_media),
            datasets: [
              {
                data: clicksCardSocial.map(
                  (item) => item.total_social_card_clicks,
                ),
                backgroundColor: "rgba(255, 101, 0, 0.75)",
                borderColor: "black",
                borderWidth: 2,
              },
            ],
          };
        }
        setChartDataClickSocial(clicksCard);

        setChartDataChannelMethod(data.data.by_channel_and_method);
      })
      .catch((error) => {
        console.log(error);
      });
  } catch {
    setCard(null);
  }
};

const getProfile = async (
  token,
  setFullName,
  setProfilePicture,
  setProfilePictureId,
  setPhoneNumber,
) => {
  try {
    const profileData = await fetch(urlApi + "/v1/dashboard/profile", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          toast.error("Something went wrong, try again later!", {
            position: "top-center",
            autoClose: 3000,
          });
          return;
        }
        setFullName(data.data.fullname ? data.data.fullname : "");
        setPhoneNumber(data.data.phone_number);
        setProfilePicture(data.data.image.url);
        return data.data;
      })
      .catch((error) => {
        console.log(error);
        toast.error("Something went wrong, try again later!", {
          position: "top-center",
          autoClose: 3000,
        });
        return;
      });
    return profileData;
  } catch {
    toast.error("Something went wrong, try again later!", {
      position: "top-center",
      autoClose: 3000,
    });
  }
};

const updateProfile = async (token, data, setLoading, image) => {
  try {
    const resp = await fetch(urlApi + "/v1/dashboard/profile", {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          setLoading(false);
          toast.error(stringError(data.errors[0]), {
            position: "top-center",
            autoClose: 3000,
          });
          return false;
        }
        setLoading(false);
        toast.success("Profile updated!", {
          position: "top-center",
          autoClose: 3000,
        });
        return true;
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error("Something went wrong, try again later!", {
          position: "top-center",
          autoClose: 3000,
        });
        return false;
      });
    return resp;
  } catch {
    setLoading(false);
    setErrorMsg("Something went wrong, try again later!");
    return false;
  }
};

const sentEmailResetPassword = (token, email, setLoading) => {
  try {
    fetch(urlApi + "/v1/users/password/forgot", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
      },
      body: JSON.stringify({
        email: email,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message == "SUCCESS") {
          toast.success("We sent you email to reset your password!", {
            position: "top-center",
            autoClose: 3000,
          });
        } else {
          console.log(data);
          toast.error("Failed to sent email! Please try again later", {
            position: "top-center",
            autoClose: 3000,
          });
        }
        setLoading(false);
        document.getElementById("change_password_modal").close();
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        document.getElementById("change_password_modal").close();
      });
  } catch {
    console.log(error);
    toast.error("something went wrong, try again later!", {
      position: "top-center",
      autoclose: 3000,
    });
  }
};

const getTicketInformations = (token, setCategory) => {
  try {
    fetch(urlApi + "/v1/ticket", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message == "SUCCESS") {
          setCategory(data.categories);
        } else {
          console.log(data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  } catch {
    console.log(error);
  }
};

const postTicket = (
  token,
  data,
  setCategory,
  setDescription,
  setLoading,
  setImageSrc,
  refFile,
) => {
  try {
    fetch(urlApi + "/v1/ticket", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message == "SUCCESS") {
          toast.success(
            "Thank you for your inquiries, we'll get back to you ASAP!",
            {
              position: "top-center",
              autoClose: 3000,
            },
          );
          setCategory("Cards");
          setDescription("");
          setImageSrc(null);
          refFile.current.value = null;
          setLoading(false);
        } else {
          toast.error(data.errors[0], {
            position: "top-center",
            autoClose: 3000,
          });
          console.log(data);
          setLoading(false);
        }
      })
      .catch((error) => {
        toast.error("something went wrong, try again later!", {
          position: "top-center",
          autoclose: 3000,
        });
        console.log(error);
        setLoading(false);
      });
  } catch {
    toast.error("something went wrong, try again later!", {
      position: "top-center",
      autoclose: 3000,
    });
    console.log(error);
    setLoading(false);
  }
};

const getContacts = (
  token,
  setContactsData,
  setUrlTemplate,
  queryName,
  queryValue,
) => {
  try {
    let url = urlApi + "/v1/contacts";
    if (queryValue) {
      url = url + `?${queryName.toLowerCase()}=${queryValue}`;
    }
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          toast.error("Something went wrong, try again later!", {
            position: "top-center",
            autoClose: 3000,
          });
          return false;
        }
        setContactsData(data.data);
        setUrlTemplate(data.template);
        return true;
      })
      .catch((error) => {
        console.log(error);
        toast.error("Something went wrong, try again later!", {
          position: "top-center",
          autoClose: 3000,
        });
        setShowError(true);
        return false;
      });
  } catch {
    toast.error("Something went wrong, try again later!", {
      position: "top-center",
      autoClose: 3000,
    });
    return false;
  }
};

const createContact = (token, data, setLoading, navigate, setStep) => {
  try {
    fetch(urlApi + "/v1/contacts", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.errors) {
          setLoading(false);
          toast.error(stringError(data.errors[0]), {
            position: "top-center",
            autoClose: 3000,
          });
          return false;
        }
        if (navigate) {
          localStorage.setItem("toastMsg", "Contact created");
          navigate("/contacts");
        }
        if (setStep) {
          toast.success("Contact connected", {
            position: "top-center",
            autoClose: 3000,
          });
          setLoading(false);
          setStep(2);
        }
      })
      .catch((error) => {
        toast.error("something went wrong, try again later!", {
          position: "top-center",
          autoclose: 3000,
        });
        console.log(error);
        setLoading(false);
      });
  } catch {
    toast.error("something went wrong, try again later!", {
      position: "top-center",
      autoclose: 3000,
    });
    console.log(error);
    setLoading(false);
  }
};

const deleteContact = async (token, data) => {
  const contactId = data.contact_id;
  let resDeleteData = await fetch(urlApi + "/v1/contacts/" + contactId, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "content-Type": "application/json",
      "Access-Control-Allow-Headers": "*",
      Authorization: "Bearer " + token,
    },
  });
  if (!resDeleteData.ok) {
    return false;
  }
  return true;
};

const getContact = (token, contactId, setContactData) => {
  try {
    fetch(urlApi + "/v1/contacts/" + contactId, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          toast.error("Something went wrong, try again later!", {
            position: "top-center",
            autoClose: 3000,
          });
          return false;
        }
        const contactData = data.data[0];
        setContactData(contactData);
        return true;
      })
      .catch((error) => {
        console.log(error);
        toast.error("Something went wrong, try again later!", {
          position: "top-center",
          autoClose: 3000,
        });
        return false;
      });
  } catch {
    toast.error("Something went wrong, try again later!", {
      position: "top-center",
      autoClose: 3000,
    });
    return false;
  }
};

const updateContact = (token, contactId, data_, setLoading, navigate) => {
  try {
    fetch(urlApi + "/v1/contacts/" + contactId, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data_),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          setLoading(false);
          toast.error(stringError(data.errors[0]), {
            position: "top-center",
            autoClose: 3000,
          });
          return false;
        }
        localStorage.setItem(
          "toastMsg",
          `${data_.first_name} ${data_.last_name} contact updated`,
        );
        navigate("/contacts");
        return true;
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error("Something went wrong, try again later!", {
          position: "top-center",
          autoClose: 3000,
        });
        return false;
      });
  } catch {
    setLoading(false);
    return false;
  }
};

const uploadFileContacts = (token, file, setLoading, setSelectedFile) => {
  const formData = new FormData();
  formData.append("file", file);
  try {
    fetch(urlApi + "/v1/contacts/import", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
      body: formData,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          setLoading(false);
          toast.error(stringError(data.errors[0]), {
            position: "top-center",
            autoClose: 3000,
          });
          return false;
        }
        document.getElementById("upload_contacts_modal").close();
        toast.success(`${data.data.total_imported} contact uploaded`, {
          position: "top-center",
          autoClose: 3000,
        });
        setLoading(false);
        setSelectedFile(null);
        return true;
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error("Something went wrong, try again later!", {
          position: "top-center",
          autoClose: 3000,
        });
        return false;
      });
  } catch {
    setLoading(false);
    return false;
  }
};

const downloadContacts = (
  token,
  format,
  selectedData,
  queryName,
  queryValue,
  setLoading,
) => {
  let url = urlApi + "/v1/contacts/export";
  if (queryValue && selectedData.includes("*")) {
    url = url + `?${queryName.toLowerCase()}=${queryValue}`;
    url = url + `&format=${format}`;
  } else if (queryValue == "" && selectedData.includes("*")) {
    url = url + `?format=${format}`;
  } else {
    url = url + `?contact_ids=${selectedData.join(",")}`;
    url = url + `&format=${format}`;
  }
  try {
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Access-Control-Allow-Headers": "*",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        const contentType = response.headers.get("content-type");
        // 1. Handle JSON (usually for errors or metadata)
        if (contentType && contentType.includes("application/json")) {
          return response.json().then((data) => {
            if (data.errors) {
              setLoading(false);
              toast.error(stringError(data.errors[0]), {
                position: "top-center",
              });
              throw new Error("Validation failed"); // Stop the chain
            }
            return data;
          });
        }
        // 2. Handle Files (vCard or Spreadsheet)
        return response.blob().then((blob) => {
          const downloadUrl = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = downloadUrl;
          // Determine extension based on type
          const ext = contentType.includes("vcard") ? "vcf" : "xlsx";
          a.download = `contacts.${ext}`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          return { success: true };
        });
      })
      .then((res) => {
        if (res?.success) {
          document.getElementById("download_contacts_modal").close();
          toast.success(`Contact downloaded`, {
            position: "top-center",
            autoClose: 3000,
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error("Something went wrong, try again later!", {
          position: "top-center",
          autoClose: 3000,
        });
        return false;
      });
  } catch {
    setLoading(false);
    return false;
  }
};

const invokeOCR = (
  token,
  imageBase64,
  setFirstName,
  setLastName,
  setCompany,
  setJobTitle,
  setPhones,
  setEmails,
  setLoading,
  setShowCapture,
) => {
  try {
    fetch(urlApi + "/v1/contacts/ocr", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        image_base64: imageBase64,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          setLoading(false);
          toast.error(stringError(data.errors[0]), {
            position: "top-center",
            autoClose: 3000,
          });
          return false;
        } else {
          if (data.data.first_name) {
            setFirstName(data.data.first_name);
          }
          if (data.data.last_name) {
            setLastName(data.data.last_name);
          }
          if (data.data.job_title) {
            setJobTitle(data.data.job_title);
          }
          if (data.data.company) {
            setCompany(data.data.company);
          }
          setLoading(false);
          toast.success("Fill information from image!", {
            position: "top-center",
            autoClose: 3000,
          });
          setShowCapture(false);
          return true;
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error("Something went wrong, try again later!", {
          position: "top-center",
          autoClose: 3000,
        });
        return false;
      });
  } catch {
    setLoading(false);
    return false;
  }
};

const uploadLinkContacts = (token, url, setLoading) => {
  try {
    fetch(urlApi + "/v1/contacts/import/thirdparty", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        scrap_url: url,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          setLoading(false);
          toast.error(stringError(data.errors[0]), {
            position: "top-center",
            autoClose: 3000,
          });
          return false;
        }
        document.getElementById("upload_contacts_modal").close();
        toast.success(`Contact uploaded`, {
          position: "top-center",
          autoClose: 3000,
        });
        setLoading(false);
        return true;
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error("Something went wrong, try again later!", {
          position: "top-center",
          autoClose: 3000,
        });
        return false;
      });
  } catch {
    setLoading(false);
    return false;
  }
};

export {
  getAllCards,
  createCard,
  getAllLookUp,
  uploadImage,
  updateCard,
  getCardBySlug,
  deleteCard,
  getAllPackages,
  postPayment,
  getAllPayment,
  getActivePayment,
  getSpecificPayment,
  getUserPackage,
  getUserTransactions,
  getAnalytic,
  createBackground,
  getVCLookUp,
  getAllBackgrounds,
  deleteBackground,
  getBackground,
  updateBackground,
  getESLookUp,
  createSignature,
  getAllSignatures,
  deleteSignature,
  getSignature,
  updateSignature,
  postGift,
  getProfile,
  updateProfile,
  sentEmailResetPassword,
  getTicketInformations,
  postTicket,
  getContacts,
  createContact,
  deleteContact,
  getContact,
  updateContact,
  uploadFileContacts,
  downloadContacts,
  invokeOCR,
  uploadLinkContacts,
};
